// @ts-nocheck
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import LoadingButton from '@mui/lab/LoadingButton';
import TitlebarImageList from './TitlebarImageList'
import styled from 'styled-components'
import React, {useState, useContext, Fragment} from "react";
import { Input, TextField, Typography, Select, MenuItem } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import HistoryIcon from '@mui/icons-material/History';
import { UserContext } from './UserContext'
import { ReactComponent as SpotIcon } from '../assets/spot.svg';
import { ReactComponent as AppleIcon } from '../assets/apple_logo.svg';

const GenerateContainer = styled.div``

const InputContainer = styled(Grid)`
    padding-top: 3%;
    padding-left: 4%;
    padding-right: 4%;
`

const ImagesContainer = styled.div`
    text-align: center;
    padding 4%;
    padding-top: 0;
`

const ButtonHelperText = styled.div`
    padding: 8px;
    display: flex;
    white-space: nowrap;
    color: DimGray;
`

const GenerateArt = () => {  
    const {user, setUser} = useContext(UserContext);
    const [images, setImages] = useState([]);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [generationStyle, setGenerationStyle] = useState("digital art");
    const [songPoolSize, setSongPoolSize] = useState(10);
    const [loadingGeneration, setLoadingGeneration] = useState(false);
    const [loadingExisting, setLoadingExisting] = useState(false);
    const [musicPlatform, setMusicPlatform] = useState(user.signed_into_spotify ? 'spotify' : 'apple_music');


    const generateImage = async () => {
        setLoadingGeneration(true)
        setError(false)
        const requestParams = {
            style: generationStyle || "digital art",
            song_pool_size: songPoolSize || 1,
            platform: musicPlatform
        }
        const options = {method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + user.firebase_token},};
        try {
            const response = await fetch(
                `${process.env.REACT_APP_DALLPAPER_API_URL}/generate-random-top-track-image?` + new URLSearchParams(requestParams),
                options
            )
            const imageResponse = await response.json()
            // Append generated image to state 
            if (response.ok) {
                images.unshift(imageResponse)
                user.generation_count += 1
                setUser(user)
                setImages(images)
            }
            else {
                setError(true)
                setErrorMsg(JSON.stringify(imageResponse.detail))
            }
            setLoadingGeneration(false)
        } 
        catch (e) {
            setError(true)
            setErrorMsg("Failed to connect to backend... is it running?")
            setLoadingGeneration(false)
        }
    }

    const getExistingUserGenerations = async () => {
        setLoadingExisting(true)
        const requestParams = { count: user.generation_count }
        const options = {method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + user.firebase_token}};
        try {
            const response = await fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/generations?` + new URLSearchParams(requestParams), options)
            const imageResponse = await response.json()

            if (imageResponse) {
                setImages(imageResponse)
            }
            setLoadingExisting(false)
        } catch (e) {
            setLoadingExisting(false)
        }
    }

    const _handleTextFieldChange = (event) => {
        setGenerationStyle(event.target.value)
    }

    const _handleTrackNumFieldChange = (event) => {
        const isNumber = !isNaN(event.target.value)
        const num = parseInt(event.target.value) || 0
        if (isNumber && Number.isInteger(num) && num <= 50 ) {
            setSongPoolSize(num)
        }
    }

    const _handlePlatformSelectChange = (event) => {
        console.log(event.target.value)
        setMusicPlatform(event.target.value)
    }

    return(
        <GenerateContainer>
            <InputContainer container direction='column' justifyContent="space-evenly" alignItems="top" spacing={2}>
                <Grid item xs={3}>
                    <LoadingButton
                        variant="contained"
                        color="inherit"
                        onClick={getExistingUserGenerations}
                        loading={loadingExisting}
                        startIcon={<HistoryIcon fontSize="large" color="inherit"/>}
                    >
                        Load History ({typeof user.generation_count === "number" ? user.generation_count : "?"})
                    </LoadingButton>
                </Grid>
                <Grid item container xs={3} spacing={3}>
                    <Grid item>
                        <LoadingButton 
                            variant="contained"
                            color={error ? "error" : musicPlatform === "spotify" ? "success" : "info"}
                            onClick={generateImage}
                            loading={loadingGeneration}
                            startIcon={musicPlatform === "spotify" 
                                ? <SpotIcon style={{ width: "18px", padding: "5%"}}></SpotIcon>
                                : <AppleIcon style={{maxWidth:"20px", fill: "white"}}></AppleIcon>
                            }
                            endIcon={<PaletteIcon color="inherit"/>}
                        >
                            {"- Generate new art -"}
                        </LoadingButton>
                        <ButtonHelperText>
                            {error
                                ? <Typography color="error" variant="caption">{errorMsg}</Typography>
                                : <Fragment>
                                    <Typography variant="caption">Picks a random song from your top </Typography>
                                    <TextField
                                        size='small'
                                        style={{ width: "40px", height: "20px", paddingLeft: "5px"}}
                                        InputProps={{
                                            style: {height: "20px", fontSize: "12px"},
                                            inputProps: { 
                                                min: 0,
                                                max: 50,
                                                style: {textAlign: "center", padding: 0, paddingTop: 1},
                                                padding: 5,
                                            },
                                        }}
                                        value={songPoolSize}
                                        onChange={_handleTrackNumFieldChange}
                                    />
                                </Fragment>
                            }
                        </ButtonHelperText>
                    </Grid>
                    <Grid item xs={6}>
                        <Select
                            color={musicPlatform === 'spotify' ? 'success' : 'info'}
                            value={musicPlatform}
                            onChange={_handlePlatformSelectChange}
                            size="small"
                        >
                            <MenuItem disabled={!user.signed_into_spotify} value="spotify">
                                Spotify
                            </MenuItem>
                            <MenuItem disabled={!user.signed_into_apple_music} value="apple_music">
                                Apple Music
                            </MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={5}>
                        <TextField
                            label="Art style"
                            placeholder="digital art"
                            defaultValue="digital art"
                            helperText="i.e. psychedelic"
                            variant="outlined"
                            color="primary"
                            onChange={_handleTextFieldChange}
                            size="small"
                        />
                    </Grid>
                </Grid>
            </InputContainer>
            <ImagesContainer>
                <TitlebarImageList images={images}/>
            </ImagesContainer>
        </GenerateContainer>
    )
}

export default GenerateArt;